export default __webpack_public_path__ + "static/media/userActive.65c09118.svg";